// extracted by mini-css-extract-plugin
export var messageSideLeft = "_th-1";
export var stateContainer = "_th-0";